import { TagIcon } from "@phosphor-icons/react";
import { Flex, Tag, Typography } from "antd";
import { ProjectTag } from "pages/media/types";
import { memo } from "react";

interface ProjectTagsProps {
  tags: ProjectTag[];
  gap?: number;
  vertical?: boolean;
  bordered?: boolean;
  fontSize?: number;
}

export const ProjectTags = memo(
  ({
    tags,
    gap = 4,
    vertical = true,
    bordered = false,
    fontSize = 12,
  }: ProjectTagsProps) => {
    if (tags.length === 0) return null;

    return (
      <Flex gap={gap} align="start" vertical={vertical}>
        {tags.map((tag, index) => (
          <Tag
            bordered={bordered}
            key={index}
            icon={
              <Typography.Text type="secondary">
                <TagIcon
                  weight="bold"
                  size={14}
                  style={{
                    verticalAlign: "text-top",
                    marginRight: 4,
                    marginTop: 3,
                  }}
                />
              </Typography.Text>
            }
          >
            <Flex gap={4} style={{ display: "inline-flex" }}>
              <Typography.Text type="secondary" style={{ fontSize }}>
                {tag.tag_key}
              </Typography.Text>
              <Typography.Text style={{ fontSize }}>
                {tag.tag_value}
              </Typography.Text>
            </Flex>
          </Tag>
        ))}
      </Flex>
    );
  }
);
ProjectTags.displayName = "ProjectTags";
